export default function AboutSection() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <span className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full mb-5 whitespace-nowrap">
                <i className="ri-information-line"></i>
                About the Resource
              </span>

              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-6 text-balance leading-tight">
                What Is Hipobuy Spreadsheet?
              </h2>

              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-4">
                <strong className="text-foreground-900">Hipobuy Spreadsheet</strong> is a powerful way for shoppers to organize, 
                discover and compare products through curated product collections. Instead of spending hours searching manually, 
                users can explore structured spreadsheets containing product categories, recommendations and useful buying information.
              </p>

              <p className="text-base text-foreground-600 leading-relaxed mb-8">
                Whether you are looking for the latest sneakers, trendy hoodies, stylish accessories, or everyday essentials, 
                Hipobuy Spreadsheet provides a centralized resource that saves time and helps you make informed purchasing decisions 
                across multiple product categories.
              </p>

              <div className="grid grid-cols-2 gap-4">
                {[
                  { icon: "ri-flashlight-line", title: "Faster Discovery", desc: "Find products through organized categories" },
                  { icon: "ri-scales-3-line", title: "Better Comparison", desc: "Compare products and prices easily" },
                  { icon: "ri-user-heart-line", title: "Beginner Friendly", desc: "Simple guides for new users" },
                  { icon: "ri-shield-check-line", title: "Safer Shopping", desc: "Learn to avoid risky links" },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-3 p-4 rounded-xl bg-background-100/70">
                    <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className={`${item.icon} text-lg text-primary-600`}></i>
                    </span>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h4>
                      <p className="text-xs text-foreground-500 mt-0.5 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20creative%20studio%20desk%20with%20large%20iMac%20displaying%20organized%20product%20catalog%20grid%20with%20fashion%20items%2C%20warm%20afternoon%20sunlight%20through%20sheer%20linen%20curtains%2C%20stylish%20ceramic%20vase%20with%20dried%20pampas%20grass%2C%20soft%20sand%20and%20cream%20palette%2C%20modern%20boho%20aesthetic%20workspace%2C%20editorial%20interior%20photography%20with%20gentle%20diffused%20light%20and%20organic%20textures&width=800&height=1000&seq=about-v2-2026&orientation=portrait"
                  alt="Hipobuy Spreadsheet workspace and product discovery"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-xl px-5 py-3 border border-background-200/60">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-600 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">Trusted Resource</p>
                    <p className="text-sm font-bold text-foreground-950">Updated Weekly</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}